import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { DialogFrame } from "component/shared/dialog-frame";
import { OutlinedButton } from "component/shared/outlined-button";
import { ClientBoardResource } from "api/resource/client-board";
import { mlsIdErrorMessage } from "component/shared/mls-id-dialogs/errors";

interface RemoveProps {
	row: ClientBoardResource | null;
	boardName: string;
	onRemove: (row: ClientBoardResource) => Promise<unknown>;
	onClose: () => void;
}

export const PlainRemoveDialog: React.FC<RemoveProps> = ({ row, boardName, onRemove, onClose }) => {
	const [error, setError] = useState<string | null>(null);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		setError(null);
		setSaving(false);
	}, [row]);

	const remove = async () => {
		if (!row) {
			return;
		}
		setSaving(true);
		try {
			await onRemove(row);
			onClose();
		} catch(e) {
			setError(mlsIdErrorMessage(e));
			setSaving(false);
		}
	};

	return (
		<DialogFrame
			open={!!row}
			onClose={onClose}
			title="Remove MLS ID"
			titleId="plain-mls-id-remove-title"
			closeDisabled={saving}
			notice={error && <Mui.Alert severity="error">{error}</Mui.Alert>}
			actions={
				<>
					<OutlinedButton onClick={onClose} disabled={saving}>Cancel</OutlinedButton>
					<Mui.Button variant="contained" color="primary" onClick={remove} disabled={saving}>Remove</Mui.Button>
				</>
			}
		>
			<Mui.Typography>
				Remove {row?.agentId} from Featured Listings on {boardName}?
			</Mui.Typography>
		</DialogFrame>
	);
};
